module.exports = __webpack_public_path__ + "img/_checked_square.bbe11638.svg";